var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialog-container" }, [
    _c("div", { staticClass: "dialog-background" }),
    _vm._v(" "),
    _c("div", { staticClass: "dialog-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "button button-circle close-btn",
          on: { click: _vm.cancel }
        },
        [
          _c("img", {
            staticClass: "icon-close",
            attrs: {
              src: "https://assets.themiilk.com/common/icon-close-white.svg",
              alt: "Close"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dialog-box share" }, [
        _c("div", { staticClass: "dialog-content" }, [
          _vm.title
            ? _c(
                "div",
                { staticClass: "section-title label-description bold" },
                [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "content-wrapper label-small",
            domProps: { innerHTML: _vm._s(_vm.content) }
          }),
          _vm._v(" "),
          _vm.facebook || _vm.twitter || _vm.kakaotalk || _vm.linkedin
            ? _c("div", { staticClass: "social-container" }, [
                _c(
                  "a",
                  {
                    staticClass: "social-item facebook",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.shareFacebook($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "social-icon remove-line-height" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "50px",
                              height: "50px",
                              viewBox: "0 0 50 51",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(-805.000000, -983.000000)",
                                      "fill-rule": "nonzero"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform:
                                            "translate(388.000000, 140.000000)"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(371.000000, 78.000000)"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  transform:
                                                    "translate(0.000000, 548.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      transform:
                                                        "translate(0.000000, 193.727922)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          transform:
                                                            "translate(46.000000, 24.000000)"
                                                        }
                                                      },
                                                      [
                                                        _c("circle", {
                                                          staticClass:
                                                            "background",
                                                          attrs: {
                                                            cx: "25",
                                                            cy: "25",
                                                            r: "25"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          staticClass: "icon",
                                                          attrs: {
                                                            d:
                                                              "M31.1705263,22.7294737 L30.7726316,26.0705263 C30.7370641,26.3919589 30.4644411,26.6345934 30.1410526,26.6326316 L26.6673684,26.6326316 L26.6673684,36.5484211 C26.6691283,36.7948602 26.4716842,36.9965352 26.2252632,37 L22.6852632,37 C22.5663307,36.9983367 22.4529316,36.9494897 22.3700182,36.8642074 C22.2871049,36.7789251 22.241471,36.6641953 22.2431579,36.5452632 L22.2621053,26.6326316 L19.6315789,26.6326316 C19.2827675,26.6326316 19,26.3498641 19,26.0010526 L19,22.66 C19,22.3111886 19.2827675,22.0284211 19.6315789,22.0284211 L22.2463158,22.0284211 L22.2463158,18.7884211 C22.2463158,15.04 24.4757895,13 27.7410526,13 L30.4157895,13 C30.7646009,13 31.0473684,13.2827675 31.0473684,13.6315789 L31.0473684,16.4452632 C31.0473684,16.7940746 30.7646009,17.0768421 30.4157895,17.0768421 L28.7768421,17.0768421 C27.0021053,17.1052632 26.6673684,17.9547368 26.6673684,19.2242105 L26.6673684,22.0189474 L30.5547368,22.0189474 C30.7341035,22.0220218 30.9037001,22.1012279 31.02119,22.2367932 C31.13868,22.3723585 31.1929768,22.5514911 31.1705263,22.7294737 L31.1705263,22.7294737 Z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "social-name" }, [
                      _vm._v("Facebook")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "social-item twitter",
                    attrs: {
                      href:
                        "https://twitter.com/intent/tweet?text=&url=" +
                        encodeURIComponent(
                          _vm.url + "?utm_source=twitter&utm_medium=share"
                        ),
                      target: "_blank"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "social-icon remove-line-height" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "50px",
                              height: "50px",
                              viewBox: "0 0 50 51",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(-890.000000, -983.000000)",
                                      "fill-rule": "nonzero"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform:
                                            "translate(388.000000, 140.000000)"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(371.000000, 78.000000)"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  transform:
                                                    "translate(0.000000, 548.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      transform:
                                                        "translate(0.000000, 193.727922)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          transform:
                                                            "translate(131.000000, 24.000000)"
                                                        }
                                                      },
                                                      [
                                                        _c("circle", {
                                                          staticClass:
                                                            "background",
                                                          attrs: {
                                                            fill: "#333333",
                                                            cx: "25",
                                                            cy: "25",
                                                            r: "25"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          staticClass: "icon",
                                                          attrs: {
                                                            d:
                                                              "M36.8020121,18.5824097 C36.2619622,19.3936497 35.6021068,20.1183756 34.8449147,20.7319098 C34.6516015,20.8930156 34.5411708,21.1326501 34.5442853,21.3842756 L34.5442853,21.459433 C34.5354694,23.0886667 34.2361668,24.7032716 33.6604349,26.2274151 C33.0671992,27.8271177 32.1858271,29.3045623 31.0599907,30.5865412 C29.5470752,32.3088632 27.6008232,33.5949465 25.4231897,34.3113393 C23.9922837,34.7757535 22.4962736,35.008173 20.9919125,34.9997806 C18.6053255,34.999485 16.2612906,34.3678402 14.1976884,33.1689476 C14.0457444,33.0825601 13.9696342,32.9057878 14.0112981,32.7360413 C14.0541143,32.5687703 14.2054066,32.4522008 14.378066,32.4534497 L14.9492618,32.4534497 C16.7629502,32.4579053 18.5365153,31.9197634 20.0419237,30.9082146 C18.2127496,30.6120397 16.7035098,29.3164154 16.1337416,27.5531907 C16.1046145,27.4650286 16.1249987,27.3680178 16.1871458,27.2990345 C16.2492928,27.2300513 16.3436581,27.1996901 16.434371,27.219492 C16.7079634,27.2709676 16.9857158,27.2971327 17.2641081,27.2976557 L17.3693284,27.2976557 C15.5979736,26.4838641 14.4709249,24.7043756 14.4923052,22.7551456 C14.4929351,22.6643281 14.5411704,22.5805008 14.6193718,22.5343189 C14.6975731,22.488137 14.7942713,22.4863736 14.8741045,22.5296736 C15.2267838,22.7265788 15.6052188,22.8732983 15.9984584,22.9655862 C14.3997955,21.3839219 14.0722347,18.9216538 15.2017905,16.9770488 C15.2439659,16.9033359 15.3196527,16.8550362 15.4042724,16.8478345 C15.4888921,16.8406329 15.5716525,16.8754477 15.625678,16.9409733 C17.8194355,19.6572058 21.0201094,21.3687149 24.4972512,21.684905 L24.5213016,21.684905 C24.5724013,21.6834242 24.6206499,21.6610203 24.6547539,21.6229376 C24.6888578,21.5848549 24.7058233,21.5344362 24.7016792,21.4834833 C24.6345644,20.8801564 24.6732238,20.269746 24.8159184,19.679707 C25.2104628,18.0483167 26.4312483,16.7431031 28.0326528,16.2405068 C28.5377778,16.0827199 29.0637263,16.0016489 29.5929193,16 C30.7928123,15.9986197 31.9518223,16.4359214 32.8517419,17.2295775 C32.9683268,17.3338776 33.1191988,17.3916584 33.2756293,17.3919173 C33.3263868,17.3908304 33.3768395,17.383767 33.425944,17.3708733 C34.2715191,17.1572106 35.0816315,16.8220266 35.8309791,16.37579 C35.9228666,16.3191093 36.0404617,16.3262929 36.1247667,16.3937369 C36.2090717,16.4611809 36.2418937,16.5743309 36.2067659,16.6764194 C35.9565979,17.4634169 35.5107751,18.1740438 34.9110532,18.7417433 C35.4513233,18.6129303 35.9786335,18.4348121 36.4863512,18.2096293 C36.5890638,18.1699774 36.7056202,18.1997241 36.7767692,18.2837478 C36.8479182,18.3677714 36.8580492,18.4876364 36.8020121,18.5824097 L36.8020121,18.5824097 Z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "social-name" }, [_vm._v("Twitter")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "social-item kakaotalk",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.shareKakao($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "social-icon remove-line-height" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "50px",
                              height: "50px",
                              viewBox: "0 0 50 51",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(-975.000000, -983.000000)",
                                      "fill-rule": "nonzero"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform:
                                            "translate(388.000000, 140.000000)"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(371.000000, 78.000000)"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  transform:
                                                    "translate(0.000000, 548.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      transform:
                                                        "translate(0.000000, 193.727922)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          transform:
                                                            "translate(216.000000, 24.000000)"
                                                        }
                                                      },
                                                      [
                                                        _c("circle", {
                                                          staticClass:
                                                            "background",
                                                          attrs: {
                                                            fill: "#333333",
                                                            cx: "25",
                                                            cy: "25",
                                                            r: "25"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          staticClass: "icon",
                                                          attrs: {
                                                            d:
                                                              "M22.0581527,23.5709805 L21.1779075,26.05496 L22.9383978,26.05496 L22.0581527,23.5709805 Z M22.0581527,23.5709805 L21.1779075,26.05496 L22.9383978,26.05496 L22.0581527,23.5709805 Z M25.2736601,13 C16.8329532,13 10,18.3538198 10,24.9616875 C10,29.2342929 12.8577822,32.980359 17.1585233,35.0985745 C15.0242303,42.4138538 13.7701824,42.8921605 22.5605757,36.7344639 C23.4593966,36.860899 24.3659903,36.9240248 25.2736601,36.9233749 C33.7143669,36.9233749 40.5473201,31.5695551 40.5473201,24.9616875 C40.5473201,18.3538198 33.7143669,13 25.2736601,13 L25.2736601,13 Z M16.8329532,29.1378277 C15.3096066,29.1378277 16.2059292,27.0316703 15.952708,23.1087513 C15.4060718,23.0122861 13.7098916,23.4865734 13.7098916,22.2486031 C13.7066716,22.0180247 13.795742,21.7957233 13.9572847,21.6311611 C14.1188274,21.4665989 14.3394414,21.3734274 14.5700399,21.3723773 C17.7855472,21.6014822 19.947976,20.7775085 19.947976,22.2285062 C19.947976,23.4865734 18.3402223,22.980131 17.7091789,23.0886544 C17.4519384,26.9995153 18.3522804,29.1378277 16.8329532,29.1378277 L16.8329532,29.1378277 Z M25.1169041,29.0092074 C23.7462941,29.6322119 23.714139,28.2294468 23.3845495,27.6104617 L20.6996008,27.6104617 C20.3700113,28.2294468 20.3418756,29.6201538 18.9712656,29.0092074 C17.9382838,28.53492 19.6183865,26.139367 20.8684149,22.2566419 C21.0335097,21.7480645 21.5073722,21.4036853 22.0420751,21.4036853 C22.5767781,21.4036853 23.0506406,21.7480645 23.2157353,22.2566419 C24.4938995,26.1956384 26.1498858,28.5309007 25.1169041,29.0092074 L25.1169041,29.0092074 Z M26.7246578,29.0092074 C25.2535631,29.0092074 26.1498858,26.9995153 25.8805871,22.2606613 C25.8805871,21.1030786 27.6812712,21.107098 27.6812712,22.2606613 L27.6812712,27.4014537 C28.5333807,27.5139964 30.398375,26.9995153 30.398375,28.2053305 C30.398375,29.4111458 28.4087798,28.8444126 26.7407353,29.0092074 L26.7246578,29.0092074 Z M34.875969,28.7559862 L32.826083,26.034863 L32.5206098,26.3403362 L32.5206098,28.2495438 C32.5195462,28.483 32.4257848,28.7064718 32.2599525,28.8707965 C32.0941202,29.0351212 31.8698016,29.126838 31.6363453,29.1257787 C30.1049599,29.1257787 31.0213795,26.923147 30.7561001,22.2606613 C30.7539554,22.025816 30.8457475,21.7998515 31.0110585,21.6330308 C31.1763695,21.4662101 31.4014903,21.3723773 31.6363453,21.3723773 C32.9667615,21.3723773 32.3919895,23.2494298 32.5165904,24.1296749 C35.012628,21.7421607 34.9523373,21.4889395 35.4668185,21.4889395 C36.1742301,21.4889395 36.6083236,22.3691846 36.1340362,22.8354332 L34.1243441,24.8451253 L36.2907922,27.6988881 C37.0022232,28.6273659 35.5914194,29.6804445 34.8920465,28.7559862 L34.875969,28.7559862 Z M21.16183,26.05496 L22.9223203,26.05496 L22.0581527,23.5709805 L21.16183,26.05496 Z M22.0581527,23.5709805 L21.1779075,26.05496 L22.9383978,26.05496 L22.0581527,23.5709805 Z M22.0581527,23.5709805 L21.1779075,26.05496 L22.9383978,26.05496 L22.0581527,23.5709805 Z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "social-name" }, [
                      _vm._v("Kakaotalk")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "social-item linkedIn",
                    attrs: {
                      href:
                        "https://www.linkedin.com/shareArticle?mini=true&url=" +
                        encodeURIComponent(
                          _vm.url + "?utm_source=linkedin&utm_medium=share"
                        ),
                      target: "_blank"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "social-icon remove-line-height" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "50px",
                              height: "50px",
                              viewBox: "0 0 50 51",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(-1060.000000, -983.000000)"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform:
                                            "translate(388.000000, 140.000000)"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(371.000000, 78.000000)"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  transform:
                                                    "translate(0.000000, 548.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      transform:
                                                        "translate(0.000000, 193.727922)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          transform:
                                                            "translate(301.000000, 24.000000)"
                                                        }
                                                      },
                                                      [
                                                        _c("circle", {
                                                          staticClass:
                                                            "background",
                                                          attrs: {
                                                            fill: "#333333",
                                                            "fill-rule":
                                                              "nonzero",
                                                            cx: "25",
                                                            cy: "25",
                                                            r: "25"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          staticClass: "icon",
                                                          attrs: {
                                                            d:
                                                              "M30.7642564,21.188668 C33.7168319,21.188668 35.9298849,23.1168751 35.9298849,27.2615239 L35.9298849,27.2615239 L35.9298849,35 L31.4433149,35 L31.4433149,27.7803193 L31.4406307,27.5812408 C31.3939597,25.8770039 30.7349447,24.7292072 29.1712596,24.7292072 C27.9311473,24.7292072 27.194216,25.5626152 26.8695703,26.3699108 C26.7515656,26.6582781 26.7207355,27.0591352 26.7207355,27.4635139 L26.7207355,27.4635139 L26.7207355,35 L22.2333018,35 L22.2337594,34.9050608 C22.2338524,34.8855768 22.2339586,34.8631997 22.2340775,34.8380278 L22.234935,34.6542493 C22.2399148,33.5755599 22.2548189,30.159041 22.2589532,27.0650856 L22.2589532,27.0650856 L22.2598824,26.091191 C22.2599394,25.9849121 22.2599801,25.8793959 22.2600035,25.7747613 L22.2600035,25.7747613 L22.2599295,25.1584836 L22.2599295,25.1584836 L22.2597234,24.8600619 L22.2589449,24.2862187 C22.2563607,22.8935101 22.2488531,21.8328765 22.2333018,21.5054733 L22.2333018,21.5054733 L26.7207355,21.5054733 L26.7207355,23.4176675 L26.7916525,23.310162 C27.4007338,22.4013215 28.4725746,21.188668 30.7642564,21.188668 Z M19.7522134,21.5054069 L19.7522134,34.9999336 L15.2668394,34.9999336 L15.2668394,21.5054069 L19.7522134,21.5054069 Z M17.5388947,15 C19.0743509,15 20.0179233,16.0072258 20.0472916,17.3313234 C20.0472916,18.6269829 19.0743509,19.663577 17.5095264,19.663577 L17.5095264,19.663577 L17.4798924,19.663577 L17.3019067,19.6586511 C15.8988053,19.580235 15,18.5751566 15,17.3313234 C15,16.0072258 16.0037707,15 17.5388947,15 Z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "social-name" }, [
                      _vm._v("LinkedIn")
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.url
            ? _c("div", { staticClass: "button-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-box btn-share",
                    on: { click: _vm.copyToClipboard }
                  },
                  [_vm._v("\n            링크 복사하기\n          ")]
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }